module.exports = __webpack_public_path__ + "media/images/display_status-96ec1f2a0e18013eac4149989632ff0b.svg";